import { render, staticRenderFns } from "./StepBackground.vue?vue&type=template&id=77b2798e&scoped=true&"
import script from "./StepBackground.vue?vue&type=script&lang=js&"
export * from "./StepBackground.vue?vue&type=script&lang=js&"
import style0 from "./StepBackground.vue?vue&type=style&index=0&id=77b2798e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2798e",
  null
  
)

export default component.exports